import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Addschedulebox from './Orderfunction';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from "date-fns";

import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import ReactToPrint from 'react-to-print';
import AddCardIcon from '@mui/icons-material/AddCard';
 export default class OrderView extends Component {

   constructor(props) {
      super(props);
	  
            this.state = {sumdata:[],scheduleData:[],slotdays:[],orderProd:[],type:'',orid:'',classtype:'',or_paystatus:'',or_orderno:'',orcuid:'',startdate:'',}
   this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => { this.ApigetOrderbyid(); }
   componentWillMount() { 
	
		if(localStorage.getItem("AYLuserid")===null)
		{
			 this.setState({redirect: true,pagename:"/Default"}); 
		}
		
		else{
		this.ApigetOrderbyid();
		}
	}
	getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
	ApigetOrderbyid(){
		let search = window.location.href;
	let type = this.getParameterByName('type',search);	
	let orid = this.getParameterByName('orid',search);
	if(orid!==null)
	{
	axios.post(Serverurl+'ajaxorders.php?action=list&or_id='+orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			sumdata:resp.data,or_paystatus:resp.data[0]["or_paystatus"],startdate:resp.data[0]["startdate"],
type:type,classtype:resp.data[0]["or_classtype"],orid:orid,or_orderno:resp.data[0]["or_orderno"],orcuid:resp.data[0]["or_cu_id"]
			},()=>{});
			if(resp.data[0]["or_booktype"]==="2")
			{
		this.ApigettrialClassslotbyid(orid);
			}
			else if(resp.data[0]["or_classtype"]==="5")
			{
			this.ApigetOrderProducts(orid);
			}
		this.Apigetcustomerslotbyid(orid);
			
     }
  
    });
	}
   }
 ApigettrialClassslotbyid(orid){
	axios.post(Serverurl+'ajaxorders.php?action=trialclasslots&or_id='+orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			slotdays:resp.data,
			
			});
			
		
     }
  
    });
	
}
ApigetOrderProducts(orid){
	axios.post(Serverurl+'ajaxproducts.php?action=orderprod&pr_or_id='+orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			orderProd:resp.data,
			
			});
			
		
     }
  
    });
	
}
	Apigetcustomerslotbyid(orid){
		
	axios.post(Serverurl+'ajaxcustomerschedule.php?action=getall&cs_or_id='+orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			scheduleData:resp.data,

			});
			
		
     }
  
    });
	
   }
 
	extendrequest(orid,classtype){
	
	 let r = window.confirm("Do you really want to Extend?");
		 if(r == true){ //sign Out logic
		  this.setState({orid:orid,classtype:classtype},()=>{
			  
			  this.refs.Addschedulebox.handleClickOpen()}); 
		 }
 
 } 
   render(){
		let stramount=0,gstval=0;
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	 return(
	 
	 	 

<React.Fragment>
<div className="boxheading">
	<Addschedulebox ref="Addschedulebox"  type={this.state.classtype} orid={this.state.orid}  updateDonenew={this.updateDonenewParent}/>				
<h2> Manual Billing </h2>
</div>

<div className="addandbacbtn"><a href='/Adminbilling' >Generate New</a></div>
{this.state.type==="1" && (
<div className="addandbacbtn"><a href='/Adminorder' >Back</a></div>
)}
{this.state.type==="2" && (
<div className="addandbacbtn"><a href='/Adminstrialclass' >Back</a></div>
)}

<div className="clear"></div>
<div className="orderleft"   >
<div  ref={el => (this.componentRef = el)}  >
 {this.state.or_paystatus==="1" && (
			<p className="validation">Not a valid invoice, as customer has not paid yet</p>
			)}
<table width="100%" className='stable' cellspacing='0' cellpadding='0'
style={{'border-width':'1px','border-style':'solid','border-collapse': 'collapse'}}>
{this.state.sumdata.map((item,index) => {  
			var sl=Number(index+1);
           return ( <React.Fragment>
		   
			
		   <tr><td colspan='3'></td></tr>
<tr><td ><img src={Serverurl+'/uploads/atha-yoga-logo.jpg'} style={{'width':'120px'}}/></td>
<td  align='center'><h2>Atha Yog</h2><h4>{item.bm_name}</h4><p style={{'text-align':'center'}}>{item.bm_address}<br/>
Mob: +91 9611771434</p></td><td width="30%"></td>
</tr>
<tr>
<td>Email: info@athayogliving.com<br/> Web: www.athayoglinving.com<br/>GSTIN:{item.bm_gstin}</td>
<td align='center' >
{item.or_booktype==="1" &&(
<h3>Tax Invoice</h3>)}
{item.or_booktype==="2" &&(
<h3>Receipt</h3>)}
</td>
<td >
{item.or_orderno!==null &&(
<p>Invoice No:{item.or_orderno}<br/>Invoice Date:{item.or_invoicedate}</p>

)}</td>
</tr>
<tr><td colspan='3'></td></tr>
<tr><td colspan='3' style={{'border-width':'1px','border-style':'solid'}}>
<table>

<tr><td >
<p>Name:{item.or_name}<br/>
Email id:{item.or_email}<br/>
Phone:{item.or_phone}</p>
<p>{item.or_billingaddress}

</p>{(item.or_couponcode!=="" && item.or_couponcode!==null ) && (

<p><b>Coupon Code</b> : {item.or_couponcode}


	</p>)}
</td></tr>

</table>
</td></tr>
<tr><td colspan='3' >
<table width="100%"  cellpadding='10'  className='optable'   cellspacing='0'>
<tr><td  style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>Sl.No.</td><td align='left' style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>Description</td><td  style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>Qty</td><td  style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>Rate</td><td  style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>GST</td><td  style={{'border-bottom-width':'1px','border-bottom-style':'solid'}}>Amount</td></tr>


   {(item.or_classtype==="5"  && this.state.orderProd.length>0)  && ( <React.Fragment>



 {this.state.orderProd.map((erows,index) => {  
			var l=Number(index+1);

 
 gstval=parseFloat( gstval) +parseFloat( erows.gstval);
                    
                     stramount=parseFloat( stramount) +parseFloat( erows.netvalue);
           return ( <React.Fragment>
<tr>
<td>{l}</td>
<td>{erows.op_pr_title}</td>
<td>{erows.op_qty}</td>
<td align='right'>Rs.{erows.op_price}</td>
<td>{erows.op_gst}%</td>
<td align='right'>Rs.{erows.netvalue}</td>

</tr>
<div className="clear"></div>
 </React.Fragment> )})}
 
	{parseFloat(item.or_extramt || 0) > 0 && (
  <tr>
    <td></td>
    <td>Extra Charges</td>
    <td></td>
    <td align="right">Rs.{item.or_extramt}</td>
    <td align="right">Rs.{item.or_gstpercentage}%</td>
    <td></td>
  </tr>
)}


 
	{item.or_discount!="0" && (
        
        <tr><td ></td><td >Discount</td><td ></td><td align='right'>Rs.{item.or_discount}</td><td ></td><td ></td></tr>
	)}
	<tr><td ></td><td >Total</td><td ></td><td align='right'>Rs.{(parseFloat(stramount)+ parseFloat(item.or_extramt)) - parseFloat(item.or_discount)} </td><td align='right'>Rs.{gstval}</td><td align='right'>Rs.{(parseFloat(stramount) - parseFloat(item.or_discount)+parseFloat(gstval)).toFixed(2)}</td></tr>
   </React.Fragment>
   )}
		

{item.or_classtype!=="5" && (
<React.Fragment>
<tr><td >{sl}</td><td ><p><b>{item.classtype} - {item.sb_title}<br/>

{(item.sm_slotname!=null && item.sm_slotname!="") && ( 
<React.Fragment>
<b>Slot</b> : {item.sm_slotname}<br/></React.Fragment>
	)}
	{item.classstartdate!=="00/00/0000" && (<React.Fragment>
{item.classstartdate} to {item.or_enddate}
	</React.Fragment>)}
</b></p>
 </td><td >1</td><td  align='right'>Rs.{item.or_totalamount}</td><td  align='right'>Rs.{item.or_gstpercentage}%</td><td ></td></tr>

{parseFloat(item.or_extramt || 0) > 0 && (
  <tr>
    <td></td>
    <td>Extra Charges</td>
    <td></td>
    <td align="right">Rs.{item.or_extramt}</td>
    <td align="right">Rs.{item.or_gstpercentage}%</td>
    <td></td>
  </tr>
)}

	{item.or_discount!="0" && (
        
        <tr><td ></td><td >Discount</td><td ></td><td align='right'>Rs.{item.or_discount}</td><td ></td><td ></td></tr>
	)}
	<tr><td ></td><td >Total</td><td ></td><td align='right'>Rs.{(parseFloat(item.or_totalamount)+ parseFloat(item.or_extramt)) - parseFloat(item.or_discount)} </td><td align='right'>Rs.{item.gstamount}</td><td align='right'>Rs.{item.total}</td></tr>
	</React.Fragment>
)}
	<tr><td  colspan='4' align='right' style={{'border-top-width':'1px','border-top-style':'solid'}} >
		{item.or_booktype==="1" &&(
		<span>Mode Of Payment: <b>{item.paymenttype}</b> </span>
		)}</td><td style={{'border-top-width':'1px','border-top-style':'solid'}}  align='right'>Total</td><td align='right' style={{'border-top-width':'1px','border-top-style':'solid'}}>
		{(item.or_classtype==="5"  && this.state.orderProd.length>0)  && ( <React.Fragment>
		<b>Rs.{(parseFloat(stramount) - parseFloat(item.or_discount)+parseFloat(gstval)).toFixed(2)}</b>
		</React.Fragment>
   )}{(item.or_classtype!=="5"  && this.state.orderProd.length===0)  && ( <React.Fragment>
		<b>Rs.{item.total}</b></React.Fragment>
   )}</td></tr>
</table>
</td></tr>
</React.Fragment>
)})}
</table>
</div>
</div>
 <Addtrailschedulebox ref="Addtrailschedulebox" updateDonenew={this.updateDonenewParent}/>

<div className="orderright">
 {this.state.slotdays.length>0 && ( <React.Fragment>
  <h4 className="subhead">Prefered Days and Slots</h4>

<table cellspacing='1' cellpadding='5' width='80%' className="gtable">
 {this.state.slotdays.map((rows,i) => {  
			var l=Number(i+1);
           return ( <tr>
<td>{l}</td><td>{rows.bt_day}</td><td>{rows.sm_slotname}</td>


 </tr> )})}
  </table>
 {(this.state.startdate==='0000-00-00'   ) && (
   <p >
		<Button variant="contained" onClick={this.refs.Addtrailschedulebox.handleClickOpen(this.state.orid,this.state.classtype,this.state.orcuid)} className="frmSecondarybtn" >
        Schedule Class
      </Button></p>
 )}
 

 </React.Fragment>
 )}
 
  {this.state.scheduleData.length>0 && ( <React.Fragment>
  <h4 className="subhead">Scheduled Slots and Dates </h4>

<table cellspacing='1' cellpadding='5' width='80%' className="gtable">
 <td>sl.No.</td><td>Schedule</td><td>Staff</td><td>Status</td>
 {this.state.scheduleData.map((erows,index) => {  
			var l=Number(index+1);
           return ( <React.Fragment>
		   <tr>
		   
		   <td>{l}</td><td>{erows.date}:{erows.sm_slotname}</td><td>{erows.st_name}</td> <td>{erows.sctatus}</td>
 </tr>
<div className="clear"></div>
 </React.Fragment> )})}

 </table>
  </React.Fragment>
 )}
  
  </div><div className="clear"></div>
  <ReactToPrint
						trigger={() => 
						<Button  id="print-barcode"variant="contained" className="frmSecondarybtn"  >
        Print 
      </Button>
						}
						content={() => this.componentRef}/> &nbsp;
						

{this.state.sumdata.map((item,index) => {  
			
           return ( <React.Fragment>
		   
		   						{((item.or_booktype==="1" || item.or_booktype==="3")  && item.or_orderno!==null) && (
<a href={Serverurl+'uploads/invoice-'+this.state.orid+'.pdf'} target='_blank'>

<Button variant="contained" className="frmSecondarybtn" endIcon={<FileDownloadIcon />} >
        Download 
      </Button>
</a>)}
&nbsp;
{(item.or_booktype==="1" && item.or_paystatus==="1" && item.or_classtype!=="5") &&(


<Button variant="contained" onClick={()=>{this.refs.Addschedulebox.Markaspaid(item.or_id,item.total,item.or_sesssion)}} className="frmSecondarybtn" endIcon={<AddCardIcon />}>
        Pay
      </Button>
)}



</React.Fragment>
)})}
</React.Fragment>
);
   } 
 }
 
 export  class  Addtrailschedulebox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {open:false,stsdate:'',errormessage:'',erropen:false,alerttyep:"error",stsdate1:'',lcid:'1',staff:'',orcuid:'',slotid:'',locid:'',orid:'',clstype:'',staffarray:[],slotData:[]}
	  
   }
     handleClickOpen =  (orid,clstype,orcuid) =>(e) => {
	 
	let strlcid="";
	  var date = new Date();
	  
	   var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 if(clstype==="1")
	 {
		strlcid="3"; 
	 }
	else if(clstype==="6")
	 {
		strlcid="6"; 
	 }
     this.setState({ stsdate:dayjs(date),lcid:strlcid,orid:orid,clstype:clstype,orcuid:orcuid,
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 ,open:!this.state.open,},()=>{this.onloadStaffbind();this.onloadslot();});
	  
	   }
	  
   onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
		
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
      })   
    }
	
	
onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getall&sm_slottype='+this.state.clstype+'&sorting=sm_order')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotData:resp.data	
							},()=>{
								
								
								 let slotApi = this.state.slotData.map(row => {
                          
          return {value:row.sm_id,display:row.sm_slotname}
        });
      
		
        this.setState({
          slotData: [{value: '0', display:'Select Slot'}].concat(slotApi)
        });
								
							})

	
			}else{
				this.setState({slotData:[]});
			}
 
    });
		
	}
	myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  } 
    handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({lcid: event.target.value});
	}
  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  handleClickClose= (e) => { this.setState({open:!this.state.open,}); }
  handleSave=(event)=>{
	let stsdate1 = this.state.stsdate1;
let lcid = this.state.lcid;
let slotid = this.state.slotid;	

let staff = this.state.staff;
  
if(stsdate1==="")
{
	
	this.setState({errormessage:"Please Enter Date",erropen:true,alertype:"error",});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}if(lcid==="")
{
	
	this.setState({errormessage:"Please Select Preference",erropen:true,alertype:"error",});
		 window.scrollTo({      top: 0    })
		 return false;
	
	
}if(slotid==="")
{
	
	this.setState({errormessage:"Please Select Slot",erropen:true,alertype:"error",});
		 window.scrollTo({
          top: 0
      })
		 return false;
		
}
if(staff==="")
{
	
	this.setState({errormessage:"Please Select Staff",erropen:true,alertype:"error",});
		 window.scrollTo({  top: 0  })
		 return false;
		
}var formData = new FormData();
formData.append('action','scheduletrail') 
formData.append('cs_date',stsdate1)
 formData.append('cs_st_id',staff)
  formData.append('cs_or_id',this.state.orid)
   formData.append('cs_sm_id',slotid)
formData.append('cuid',this.state.orcuid)
	 formData.append('lc_id',lcid) 
	 formData.append('or_booktype',this.state.clstype)
	 
	 	 formData.append('userid',localStorage.getItem("AYLuserid"))
	 axios.post(Serverurl+"ajaxcustomerschedule.php", formData, {
        }).then(res => {
				if(res.data !==0)
				{
					
				this.setState({errormessage:"Request accepted successfully",alertype:"info",erropen:true,},()=>{this.setState({open:false},()=>{this.props.updateDonenew();})});
					
		}else if(res.data ===-1)
				{
					
				this.setState({errormessage:"Max slot limit has been reached",erropen:true,alertype:"error",});
					
		}else if(res.data ===-2)
				{
					
				this.setState({errormessage:"Staff is not available on selected date",erropen:true,alertype:"error",});
					
		}else{
			this.setState({errormessage:"Please check with another date/slot and staff",erropen:true,alertype:"error",});
		}
		
  });
  }
  render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  Schedule
	  </DialogTitle>
      <DialogContent><p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>  <div className="scheduelpop">
	  <ul>
	  <li><p><span className="validation">*</span> Date
		</p>
	<p>
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.stsdate) }
className="txtbox" minDate={dayjs(Date.now()) }


    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
	  </li>
	   {(this.state.clstype!=="1" &&  this.state.clstype!=="6")&& (
	  <React.Fragment>
	  <li>
<p><span className="validation">*</span>Select Your Location</p>

<FormControl className="location">
  
      <RadioGroup  value={this.state.lcid}
        defaultValue={this.state.lcid}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangeClass}
      >
	  {(this.state.clstype==="3" || this.state.clstype==="4"  || this.state.clstype==="2")&& (
	  <React.Fragment>
	   <FormControlLabel value="5" control={<Radio />} label="Studio Class" />
        <FormControlLabel value="4" control={<Radio />} label="Personal Training Room 03 " />
		</React.Fragment>
	  )}
	   
	   {(this.state.clstype==="2" )&& (
	  <React.Fragment>
        <FormControlLabel value="1" control={<Radio />} label="Personal Training Room 01 " />
		<FormControlLabel value="2" control={<Radio />} label="Personal Training Room 02 " />
		</React.Fragment>
	  )}
	   {(this.state.clstype==="6" )&& (
	  <React.Fragment>
        <FormControlLabel value="6" control={<Radio />} label="Personal Training Online" />
		</React.Fragment>
	  )}
      </RadioGroup>
    </FormControl>

</li>
</React.Fragment>
	  )}
<li>
<p><span className="validation">*</span> Select Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.slotid}
			onChange={this.myChangeHandler}
			name='slotid'
			
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
<li><p><span className="validation">*</span> Select Staff</p>
<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
</li>

</ul>

		
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave}  className="frmSecondarybtn">
          Save
        </Button>
		</div></div>
<div className="clear"></div>	</div>
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 





